import { useTranslation } from "react-i18next";

import { REPORT_REASONS, type CommentReportReason } from "@/entities/comment";
import { Sheet } from "@/shared/ui";

import { useReportComment } from "../model/useReportComment";

/**
 * Выбор причины жалобы (доработки §6.2).
 *
 * Список причин, а не поле «расскажите, что не так»: по свободному тексту
 * нельзя ни отсортировать очередь модерации, ни увидеть, что робота заваливают
 * именно скамом. Тот же список — на бэкенде, в `CommentReportReason`.
 *
 * Одно нажатие отправляет жалобу и закрывает шит: подтверждение «вы уверены?»
 * поверх выбора причины — это второй вопрос там, где человек уже ответил.
 */
interface ReportSheetProps {
  commentId: number;
  onClose: () => void;
  onSent: () => void;
}

export function ReportSheet({ commentId, onClose, onSent }: ReportSheetProps) {
  const { t } = useTranslation();
  const report = useReportComment(commentId);

  return (
    <Sheet title={t("robots.comments.reportTitle")} onClose={onClose}>
      <div className="flex flex-col gap-1">
        {REPORT_REASONS.map((reason: CommentReportReason) => (
          <button
            key={reason}
            type="button"
            data-haptic="tap"
            disabled={report.isPending}
            onClick={() => {
              report.mutate(
                { reason },
                {
                  // Повторная жалоба — тоже успех: бэкенд отвечает тем же
                  // результатом, а счётчик не растёт. Отдельной ветки на
                  // «уже жаловались» здесь нет намеренно.
                  onSuccess: onSent,
                  onError: onClose,
                },
              );
            }}
            className="press-row rounded-2xl px-4 py-3.5 text-left text-body font-medium text-text-primary"
          >
            {t(`robots.comments.reportReason.${reason}`)}
          </button>
        ))}
      </div>
    </Sheet>
  );
}
